module.exports = __webpack_public_path__ + "img/clear-input.30566690.svg";